import { Header1, Header2 } from '@cian/ui-kit/typography/Header';
import { InlineText1 } from '@cian/ui-kit/typography/InlineText';
import { numberToPrettyString } from '@cian/utils';

import { FC } from 'react';

import { CoworkingProfitBanner } from 'shared/components/StickyCoworkingCard/CoworkingProfitBanner';

import { IInfoCost } from './types';

import * as styles from './InfoCost.css';

export const InfoCost: FC<IInfoCost> = props => {
  const { priceAllPerMonth, priceForWorkplace } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['cost-header']}>
        <Header1 as="span" color="black_100" fontWeight="bold">
          {`${numberToPrettyString(priceForWorkplace)} ₽`}
        </Header1>
        <Header2 as="span" color="black_100" fontWeight="bold">
          /мес. за рабочее место
        </Header2>
      </div>
      <div className={styles['cost-for-all-office-container']}>
        <InlineText1 as="span" color="black_60" fontWeight="normal">
          {`${numberToPrettyString(priceAllPerMonth)} ₽/мес. за весь офис`}
        </InlineText1>
        <CoworkingProfitBanner containerClassName={styles['coworking-profit-banner-container']} />
      </div>
    </div>
  );
};

InfoCost.displayName = 'InfoCost';
